const links = {
  MAIN_PAGE: {
    href: "/",
    title: "Main page",
    description: undefined,
    icon: undefined,
  },
  TIME_TRACKING_SOFTWARE: {
    href: "/features/employee-tracking-software/",
    title: "Time tracking software",
    description: undefined,
    icon: undefined,
  },
  FEATURES: {
    href: "/features/",
    title: "Features",
    description:
      "See how tracked time powers reporting, invoicing, project management, and workload planning",
    icon: "menu-features",
  },
  SMART_TIME_TRACKING: {
    title: "Smart time tracking",
    description: "Flexible time logging for real work",
    href: "/features/time-tracking-app",
    icon: "menu-time-tracker",
  },
  TEAM_MANAGEMENT: {
    title: "Team management",
    description: "Organize teams and track workload balance",
    href: "/features/team-management",
    icon: "menu-management",
  },
  CUSTOM_REPORTS: {
    title: "Advanced reporting",
    description: "Analyze time and compliance data",
    href: "/features/time-reporting",
    icon: "menu-custom-report",
  },
  PTO_AND_LEAVE: {
    title: "Time off",
    description: "Simplified time-off management",
    href: "/features/pto-vacation-and-leave-tracker/",
    icon: "menu-pto",
  },
  WORK_ANOMALIES: {
    title: "Work anomalies",
    description: "Auto-detect unusual work patterns",
    href: "/features/employee-performance",
    icon: "menu-anomalies",
  },
  ROLES_AND_PERMISSIONS: {
    title: "Roles & permissions",
    description: "Control access and permissions",
    href: "/features/roles-and-permissions",
    icon: "menu-roles",
  },
  PAY_RATES: {
    title: "Pay rates & invoices",
    description: "Set pay rates and generate invoices",
    href: "/features/pay-rates-and-invoicing",
    icon: "menu-pay",
  },
  ATTENDANCE_AND_TIME_CARDS: {
    title: "Schedules & attendance",
    description: "Set schedules, manage attendance and breaks",
    href: "/features/schedules-and-attendance",
    icon: "menu-attendance",
  },
  CLIENTS_PROJECTS_AND_TASKS: {
    title: "Clients, projects & tasks",
    description: "Organize work across clients and projects",
    href: "/features/clients-projects-and-tasks/",
    icon: "menu-goal",
  },
  TIME_AND_FINANCIAL_DASHBOARD: {
    title: "Time & financial dashboard",
    description: "View key time and financial metrics",
    href: "/features/dashboard/",
    icon: "menu-activity",
  },
  TIMESHEETS_AND_EXPENSES: {
    title: "Timesheets & expenses",
    description: "Create timesheets and track expenses",
    href: "/features/timesheets-and-expenses/",
    icon: "menu-invoice",
  },

  USE_CASES: {
    href: "/use-cases/",
    title: "Use cases",
    description: "Track time, manage client work, and understand team capacity across different ways of working",
    icon: "menu-use-cases",
  },
  FOR_AGENCIES: {
    href: "/use-cases/time-tracking-software-for-agencies/",
    title: "For agencies",
    description: "Manage client projects, billable time, and invoices",
    icon: "menu-for-agencies",
  },
  FOR_FREELANCERS: {
    href: "/use-cases/time-tracking-software-for-freelancers/",
    title: "For freelancers",
    description: "Keep accurate records of billable and non-billable hours",
    icon: "menu-for-freelancers",
  },
  FOR_REMOTE_TEAMS: {
    href: "/use-cases/time-tracker-for-remote-teams/",
    title: "For remote teams",
    description: "Track time and balance team workload",
    icon: "menu-for-remote-teams",
  },
  FOR_ENTERPRISES: {
    href: "/use-cases/enterprise-time-tracking-software",
    title: "For enterprises",
    description: "Scale time tracking across departments",
    icon: "menu-for-enterprises",
  },
  FOR_SMALL_AND_MEDIUM_BUSINESSES: {
    href: "/use-cases/time-tracking-software-for-small-business",
    title: "For small & medium businesses",
    description: "Streamline time tracking as your team grows",
    icon: "menu-for-small-business",
  },
  TOOLS_AND_CALCULATORS: {
    href: "/tools/",
    title: "Tools & calculators",
    description: "Access our free productivity calculators and tools designed to help you optimize your workflow",
    icon: "menu-tools-and-calculators",
  },

  TIME_SHEET_CALCULATOR_TOOL: {
    href: "/tools/timesheet-calculator",
    title: "Timesheet calculator tool",
    description: undefined,
    icon: "menu-timesheet-calc-tool",
  },
  TIME_CONVERSION_TOOLS: {
    href: "#",
    title: "Time conversion tools",
    description: undefined,
    icon: "menu-timesheet-calc-tool",
  },
  POMODORO_TIMER: {
    href: "/tools/pomodoro-timer",
    title: "Pomodoro timer",
    description: undefined,
    icon: undefined,
  },
  STOPWATCH: {
    href: "/tools/online-stopwatch",
    title: "Stopwatch",
    description: undefined,
    icon: undefined,
  },
  GLOBAL_TIME_ZONE_CONVERTER: {
    href: "/tools/time-zone-converter",
    title: "Global time zone converter",
    description: undefined,
    icon: undefined,
  },
  MILITARY_TIME_CONVERTER: {
    href: "/tools/military-time-converter",
    title: "Military time converter",
    description: undefined,
    icon: undefined,
  },
  COUNTDOWN_TIMERS_WITH_ALARM: {
    href: "/tools/online-timer",
    title: "Countdown timers with alarm",
    description: undefined,
    icon: undefined,
  },
  FINANCIAL_AND_CALCULATION_TOOLS: {
    href: undefined,
    title: "Financial & calculation tools",
    description: undefined,
    icon: "menu-financial-calc-tool",
  },
  TIMESHEET_CALCULATOR_TOOL: {
    href: "/tools/timesheet-calculator",
    title: "Timesheet calculator tool",
    description: undefined,
    icon: undefined,
  },
  HOURLY_RATE_EARNINGS_CALCULATOR: {
    href: "/tools/paycheck-calculator",
    title: "Hourly rate earnings calculator",
    description: undefined,
    icon: undefined,
  },
  OVERTIME_PAY_RATE_CALCULATOR: {
    href: "/tools/overtime-calculator",
    title: "Overtime pay rate calculator",
    description: undefined,
    icon: undefined,
  },
  PROJECT_LABOR_COST_CALCULATOR: {
    href: "/tools/labor-cost-calculator",
    title: "Project labor cost calculator",
    description: undefined,
    icon: undefined,
  },
  SALARY_CALCULATOR: {
    href: "/tools/salary-calculator/",
    title: "Salary calculator",
    description: undefined,
    icon: undefined,
  },
  DECIMAL_HOURS_CONVERTER: {
    href: "/tools/time-converter-calculator",
    title: "Decimal hours converter",
    description: undefined,
    icon: undefined,
  },
  FREE_TIMESHEET_TEMPLATES: {
    href: "/tools/timesheet-templates/",
    title: "Free timesheet templates",
    description: undefined,
    icon: "menu-free-timesheet-templates",
  },
  PAY_STUB_TEMPLATES: {
    href: "/tools/free-pay-stub-templates/",
    title: "Pay stub templates",
    description: undefined,
    icon: undefined,
  },
  SCHEDULE_TEMPLATES: {
    href: "/tools/schedule-templates/",
    title: "Schedule templates",
    description: undefined,
    icon: undefined,
  },
  TODO_LIST_TEMPLATES: {
    href: "/tools/to-do-list-templates/",
    title: "To-do list templates",
    description: undefined,
    icon: undefined,
  },
  EXPENSE_REPORT_TEMPLATES: {
    href: "/tools/expense-report-templates/",
    title: "Expense report templates",
    description: undefined,
    icon: undefined,
  },
  FREE_INVOICE_GENERATOR: {
    href: "/tools/invoice-generator/",
    title: "Free invoice generator",
    description: undefined,
    icon: undefined,
  },
  WORK_HOUR_CALENDAR: {
    href: "/tools/work-hours-calculator/",
    title: "Work hour calendar",
    description: undefined,
    icon: undefined,
  },
  PRICING: {
    href: "/pricing/",
    title: "Pricing",
    description: undefined,
    icon: undefined,
  },
  COMPANY: {
    href: "/about/",
    title: "Company",
    description: "Explore Traqq and connect with our team",
    icon: "menu-company",
  },
  ABOUT_US: {
    href: "/about/",
    title: "About us",
    description: "Learn more about Traqq, our approach to time tracking, and our product vision",
    icon: "menu-smile",
  },
  CONTACT_US: {
    href: "/contact?utm_source=main&utm_medium=test_page&utm_campaign=button&utm_term=Contact+Us",
    title: "Contact us",
    description: "Get in touch with our team. We're happy to answer questions or help with your account",
    icon: "menu-mail",
  },
  BLOG: {
    href: "/blog/",
    title: "Blog",
    description: "Articles about employee time tracking & workforce management solutions for businesses of all types and sizes.",
    icon: "blog",
  },
  REQUEST_DEMO: {
    href: "/demo",
    title: "Request Demo",
    description: undefined,
    icon: undefined,
  },
  GETTING_STARTED: {
    href: "/support/getting-started",
    title: "Getting started",
    description: undefined,
    icon: undefined,
  },
  MANAGING_TEAMS_PERMISSIONS: {
    href: "/support/managing-users-teams-roles-and-permissions",
    title: "Managing teams & permissions",
    description: undefined,
    icon: undefined,
  },
  WORK_ATTENDANCE: {
    href: "/support/schedules-attendance-time-off",
    title: "Work schedules & attendance",
    description: undefined,
    icon: undefined,
  },
  PAY_RATES_INVOICES: {
    href: "/support/pay-rates-and-invoices",
    title: "Pay rates & invoices",
    description: undefined,
    icon: undefined,
  },
  CLIENTS_PROJECTS_TASKS: {
    href: "/support/clients-projects-tasks-and-tags",
    title: "Clients, projects & tasks",
    description: undefined,
    icon: undefined,
  },
  REPORTS: {
    href: "/support/reports",
    title: "Reports & dashboard",
    description: undefined,
    icon: undefined,
  },
  TIMESHEETS_EXPENSES: {
    href: "/support/timesheets-expenses-approvals",
    title: "Timesheets & expenses",
    description: undefined,
    icon: undefined,
  },
  BROWSER_EXTENSIONS: {
    href: "/support/browser-extension-and-integrations",
    title: "Browser extension & integrations",
    description: undefined,
    icon: undefined,
  },
  AI_TIME_TRACKING_TOOLS: {
    href: "/features/ai-time-tracking-tools",
    title: "AI time tracking tools",
    description: undefined,
    icon: undefined,
  },
  PRODUCT_UPDATES: {
    href: "/updates",
    title: "Product updates",
    description: undefined,
    icon: undefined,
  },
  TIME_TRACKING_SUPPORT: {
    href: "/support",
    title: "Time tracking support",
    description: undefined,
    icon: undefined,
  },

  SIGNUP: {
    href: `${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/login`,
    title: undefined,
    description: undefined,
    icon: undefined,
  },
  TRAQQ_VS_CLOCKITY: {
    href: "/blog/traqq-vs-clockify-which-time-tracking-solution-is-right-for-you/",
    title: "Traqq vs Clockity",
    description: undefined,
    icon: undefined,
  },
  TRAQQ_VS_ACTIVTRAK: {
    href: "/blog/traqq-the-best-activtrak-alternative/",
    title: "Traqq vs ActivTrak",
    description: undefined,
    icon: undefined,
  },
  TRAQQ_VS_TIME_DOCTOR: {
    href: "/blog/traqq-vs-time-doctor-a-fresh-take-on-productivity-tracking-in-2025/",
    title: "Traqq vs Time Doctor",
    description: undefined,
    icon: undefined,
  },
  RESOURCES: {
    title: "Resources",
    href: undefined,
    description: undefined,
    icon: undefined,
  }
}

export default links
